/**
 * 媒资库控制器，需要继承素材库主控制器
 */
'use strict';

angular.module('resourceCenterMediaResourceModule', []).controller('MediaResourceCtrl', [
    '$scope',
    '$controller',
    'mrApiService',
    '$q',
    'modalDialog',
    '$stateParams',
    '$element',
    '$compile',
    'globleParamsSet',
    'localStorageService',
    '$sessionStorage',
    function ($scope, $controller, mrApiService, $q, modalDialog, $stateParams, $element, $compile, globleParamsSet, localStorageService, $sessionStorage) {
        // eslint-disable-next-line no-unused-vars
        initScope();
        initStatus();
        initData();

        /**
         * [initScope 初始化作用域，继承素材库主控制器]
         *
         * @return  {[type]}          [return description]
         * \
         */
        function initScope() {
            let vm = this || window;
            let parentCtr = $controller('resCenterMRRelCtrl', { $scope: $scope, mrApiService: mrApiService, $q: $q, });
            vm = angular.extend(vm, parentCtr);
        }

        /**
         * [initScope 初始化状态]
         *
         * @return  {[type]}          [return description]
         */
        function initStatus() {
            $scope.title = '素材库';
            $scope.basicalStatus.commonParams.mrType = 'meizi';
            $scope.basicalStatus.commonParams.mainResourceType = $stateParams.resourcetype;
            $scope.basicalStatus.buttonCheck.name = 'mzmaterial';
            $scope.basicalStatus.buttonCheck.ModalName = '媒资素材库';
            $scope.status = {
                isPurePic: false,
            };
        }

        $scope.purePicForMeizi = function() {
            $scope.status.isPurePic = !$scope.status.isPurePic;
            if ($scope.status.isPurePic) {
                $scope.basicalStatus.searchParams.isPureMaterial = 2;
            } else {
                delete $scope.basicalStatus.searchParams.isPureMaterial;
            }
            $scope.basicalStatus.isWithFilters = true;
            $scope.requestData();
        };

        /**
         * [initScope 初始化数据]
         *
         * @return  {[type]}          [return description]
         */
        function initData() {
            $scope.requestData();
            initMessageChange();
        }

        // TODO 提取为公共方法
        /**
         * [initScope 初始化信息编辑组件]
         *
         * @return  {[type]}          [return description]
         */
        function initMessageChange() {
            var message = '<message-change></message-change>';
            message = $compile(message)($scope);
            $element.find('messageChange').append(message);
        }

    },
]);
